/**
 * User Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserAliasPatternPartTransform } from './userAliasPatternPartTransform';
import { UserAliasPatternPartSelectionCriteria } from './userAliasPatternPartSelectionCriteria';


export interface UserAliasPatternPartViewModel { 
    id?: string | null;
    order?: number;
    attribute?: string | null;
    selectionCriteria?: UserAliasPatternPartSelectionCriteria;
    extraData?: string | null;
    transform?: UserAliasPatternPartTransform;
}

